import { Builder } from "@builder.io/react";
import { ProductTileType } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/types";

import { BuilderRetailerProductTilesSection } from "./BuilderRetailerProductTileSection";

export const registerBuilderRetailerProductTileSection = () => {
  Builder.registerComponent(BuilderRetailerProductTilesSection, {
    name: "RetailerProductTileSection",
    hideFromInsertMenu: false,
    noWrap: true,
    canHaveChildren: false,
    inputs: [
      {
        name: "products",
        type: "list",
        helperText: "Duplicate products will be automatically removed.",
        subFields: [
          {
            name: "token",
            type: "string",
          },
          {
            name: "productTileType",
            type: "enum",
            defaultValue: ProductTileType.TILE_WITHOUT_BRAND,
            enum: Object.values(ProductTileType),
            required: true,
          },
        ],
        required: true,
      },
      {
        name: "columns",
        friendlyName: "Number of Columns",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
            defaultValue: 2,
          },
          {
            name: "tabletAndAbove",
            type: "number",
            defaultValue: 2,
          },
          {
            name: "desktopAndAbove",
            type: "number",
            defaultValue: 2,
          },
          {
            name: "xLargeAndAbove",
            type: "number",
            defaultValue: 2,
          },
          {
            name: "xxLargeDesktop",
            type: "number",
            defaultValue: 2,
          },
        ],
      },
      {
        name: "rowGap",
        friendlyName: "Row Gap (px)",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "tabletAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "desktopAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "xLargeAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "xxLargeDesktop",
            type: "number",
            defaultValue: 8,
          },
        ],
      },
      {
        name: "columnGap",
        friendlyName: "Column Gap (px)",
        type: "object",
        subFields: [
          {
            name: "mobileAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "tabletAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "desktopAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "xLargeAndAbove",
            type: "number",
            defaultValue: 8,
          },
          {
            name: "xxLargeDesktop",
            type: "number",
            defaultValue: 8,
          },
        ],
      },
    ],
  });
};
